import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FileInputComponent } from '../file-input/file-input.component';

@Component({
  selector: 'app-image-upload',
  templateUrl: './image-upload.component.html',
  styleUrl: './image-upload.component.scss',
})
export class ImageUploadComponent implements OnChanges {
  @Input() image: string;
  @Input() uploadText = 'Upload Image';
  @Input() maxWidth = 200;
  @Input() maxHeight = 200;

  @Output() fileUpload: EventEmitter<File> = new EventEmitter<File>();
  @Output() fileDelete: EventEmitter<void> = new EventEmitter<void>();

  fileData: File = null;
  previewUrl: any = null;
  private previousImageUrl: string = null;

  @ViewChild('file') fileRef!: FileInputComponent;

  ngOnChanges(changes: SimpleChanges): void {
    // When image URL changes from backend (after upload success), clear local preview
    if (
      changes['image'] &&
      changes['image'].currentValue !== this.previousImageUrl
    ) {
      const newImageUrl = changes['image'].currentValue;
      // Only clear preview if we have a new backend URL and it's different from before
      if (
        newImageUrl &&
        this.previewUrl &&
        newImageUrl !== this.previousImageUrl
      ) {
        this.previewUrl = null;
        this.fileData = null;
        if (this.fileRef) {
          this.fileRef.clear();
        }
      }
      this.previousImageUrl = newImageUrl;
    }
  }

  onFileSelect(fileInput: any) {
    this.fileData = fileInput.target.files[0] as File;
    if (this.fileData) {
      this.preview();
      this.fileUpload.emit(this.fileData);
    }
  }

  preview() {
    const mimeType = this.fileData.type;
    const fileName = this.fileData.name.toLowerCase();

    // Check if file is HEIC/HEIF format
    const isHeic =
      fileName.endsWith('.heic') ||
      fileName.endsWith('.heif') ||
      mimeType === 'image/heic' ||
      mimeType === 'image/heif';

    if (isHeic) {
      // Browsers can't preview HEIC files natively
      // Skip local preview and let backend handle conversion
      // The image will be displayed after successful upload from backend URL
      this.previewUrl = null;
      return;
    }

    if (mimeType && !mimeType.match(/image\/*/)) {
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(this.fileData);
    reader.onload = (event) => {
      this.previewUrl = reader.result;
    };
  }

  removePicture(event: Event) {
    event.stopPropagation();
    this.clearImage();
    this.fileDelete.emit();
  }

  private clearImage() {
    this.image = this.previewUrl = null;
    this.fileData = null;
    this.fileRef.clear();
  }

  noImage(): boolean {
    return !this.image && !this.previewUrl;
  }
}
